module.exports = __webpack_public_path__ + "img/instagram.d76ee75d.svg";